import React from 'react';
import PropTypes from 'prop-types';

function H2HeaderText({ title, className, textColor, textAlign, fontWeight }) {
  return <h2 className={`${textColor} ${textAlign} ${fontWeight} ${className && className}`}>{title}</h2>;
}

export default H2HeaderText;

H2HeaderText.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  textColor: PropTypes.string,
  textAlign: PropTypes.string
};

H2HeaderText.defaultProps = {
  textColor: 'text-gray-700',
  textAlign: 'text-left',
  fontWeight: 'text-bold'
};
